import { v4 as uuidv4 } from 'uuid';

export function SearchFetchPrevious(props = {}) {
	return {
		componentName: 'SearchFetchPrevious',
		componentId: uuidv4(),
		props: Object.assign(
			{
				htmlElementForButton: '',
			},
			props,
		),
	};
}
